import educationalMaterials from './educational-materials';
import finance from './finance';
import learningTrails from './learning-trails';
import sitFinance from './sit-finance';

export const Role = { educationalMaterials, finance, learningTrails, sitFinance };
